/**
 * @generated SignedSource<<d711780e66f78f1bb7386cedac807268>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreSelector_store$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly workspaceBreadcrumbs: ReadonlyArray<string>;
  readonly " $fragmentType": "StoreSelector_store";
}>;
export type StoreSelector_store$key = ReadonlyArray<{
  readonly " $data"?: StoreSelector_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreSelector_store">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "StoreSelector_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeExternalId",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "workspaceBreadcrumbs",
      "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "b36f80b2ca32c34cb4d208156bbeb49c";

export default node;
